/**
 * Created by evgenijsenkevic on 04.09.2024
 */

const AdminLocationDataView = cc.Node.extend({
    ctor: function (activeLocation, options) {
        this._super();

        this.activeLocation = activeLocation;
        this.setContentSize(options.width, options.height);
        this.createBg();
        this.createContent();

        this.setAnchorPoint(0.5, 0.5);
    },

    createBg: function () {
        const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_miniature_bg);
        bg.setContentSize(this.width, this.height);
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg);
    },

    createDropDown: function (title, items, value, callback) {
        const styles = cleverapps.styles.AdminLocationDataView;

        const label = cleverapps.UI.generateOnlyText(title, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);

        const dropdown = new DropDown({
            availableItems: items,
            value,
            size: cc.size(styles.dropdown.width, label.height),
            font: cleverapps.styles.FONTS.ADMIN_DATA_TEXT
        });

        dropdown.setDelegate({
            editBoxEditingDidEnd: function (dropdown) {
                callback(dropdown.value);
            }
        });

        const layout = new cleverapps.Layout([label, dropdown], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.dropdown.margin
        });

        cleverapps.UI.fitToBox(layout, {
            width: this.availableWidth
        });

        return layout;
    },

    createMapTilesChooser: function () {
        const availableTiles = Map2d.AVAILABLE_TILES.map((tilesTexture) => tilesTexture.replace("tiles_", ""));
        availableTiles.sort((a, b) => a.localeCompare(b));

        return this.createDropDown("Map tiles:", availableTiles, this.activeLocation.tiles, (value) => {
            this.activeLocation.tiles = value;
            cleverapps.administrator.adminLocations.save(this.activeLocation);
        });
    },

    createMapUnitsChooser: function () {
        const availableUnits = Map2d.AVAILABLE_UNITS.map((tilesTexture) => tilesTexture.replace("units_", ""));
        availableUnits.sort((a, b) => Boolean(b === "main") - Boolean(a === "main") || a.localeCompare(b));

        return this.createDropDown("Unit skin:", availableUnits, this.activeLocation.units, (value) => {
            this.activeLocation.units = value;
            cleverapps.administrator.adminLocations.save(this.activeLocation);
        });
    },

    createVersionLabel: function () {
        const version = this.activeLocation.version;
        if (!version) {
            return undefined;
        }

        const label = cleverapps.UI.generateOnlyText("Version:", cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
        const value = cleverapps.UI.generateOnlyText(version, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);

        return new cleverapps.Layout([label, value], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.AdminLocationDataView.dropdown.margin
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.AdminLocationDataView;

        const mapTilesChooser = this.createMapTilesChooser();
        const mapUnitsChooser = this.createMapUnitsChooser();
        const versionLabel = this.createVersionLabel();

        const items = [mapTilesChooser, mapUnitsChooser, versionLabel].filter((item, index, array) => {
            if (item) {
                item.setAnchorPoint(0, 0.5);
                item.setLocalZOrder(array.length - index);
                return true;
            }
            return false;
        });

        const layout = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        layout.setAnchorPoint(0.5, 0.5);
        layout.setAlignment(styles.layout);
        layout.setContentSize(this.width - 10, this.height - 10);
        this.addChild(layout);
    }
});

cleverapps.styles.AdminLocationDataView = {
    margin: 10,
    layout: {
        x: { align: "center" },
        y: { align: "center" }
    },
    dropdown: {
        width: 180,
        margin: 10
    }
};